import { createFileRoute } from "@tanstack/react-router"
import type { ProductId } from "@/money/model"
import { Purchase } from "@/money"

export const Route = createFileRoute("/(user)/t/$tenantSlug/purchase")({
  component: RouteComponent,
  validateSearch: (search) =>
    search as {
      base?: ProductId
    },
})

function RouteComponent() {
  const { base } = Route.useSearch()

  return <Purchase base={base} />
}
